<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-1">The Return of the Raven Mocker</p>
<p class="book-subtitle" xml:lang="en-GB">An Alafair Tucker Mystery</p>
<p class="book-author" xml:lang="en-GB">Donis Casey</p>
<p class="body-center"><a class="calibre1" href="http://www.DonisCasey.com" target="_blank"><span class="hyperlink" xml:lang="en-US">www.DonisCasey.com</span></a></p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><span class="calibre1"><img alt="33051.png" class="frame" src="OEBPS/image/33051.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Return_of_the_Raven_Mocker.vue?509e6665